import { useMemo } from 'react';

import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters';
import { JIRA_AI_NATIVE_SIGNUP_SOURCE } from '@/components/user-context/helpers/cohorts';
import { experiments } from '@/utils/experiment/manifest';
import { getExperiment } from '@/utils/experiment/use-experiment';

type WorkStyleChoiceTreatment = {
	readonly isEligible: boolean;
	readonly isEnabled: boolean;
};

export const useWorkStyleChoiceTreatment = (): WorkStyleChoiceTreatment => {
	const { signupSource, templateChoice } = useSearchParameters();
	const isEligible = signupSource !== JIRA_AI_NATIVE_SIGNUP_SOURCE && !templateChoice;

	const isEnabled = useMemo(() => {
		if (!isEligible) {
			return false;
		}
		const workStyleChoiceResult = getExperiment(experiments.jiraSignupWorkStyleChoice);
		return workStyleChoiceResult.type === 'enrolled' && workStyleChoiceResult.value;
	}, [isEligible]);

	return { isEligible, isEnabled };
};
